<template>
  <div>
    <div class="groupResource-title">
      <div>{{ $t("RAM.AWS.IAM.Group.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:iamConfig:groupResource:update'
          ]"
          :loading="loading"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:iamConfig:groupResource:export'
          ]"
          :loading="modal_loading"
          @click="exportList"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <div class="groupResource-top">
      <group-resource-search
        ref="groupResourceSearchChild"
      ></group-resource-search>
    </div>
    <table-group-resource></table-group-resource>
  </div>
</template>

<script>
import TableGroupResource from "../group/TableGroupResource";
import GroupResourceSearch from "../group/GroupResourceSearch";

export default {
  name: "GroupResource",
  components: {
    GroupResourceSearch,
    TableGroupResource
  },
  data() {
    return {
      loading: false,
      modal_loading: false,
      companyId: ""
    };
  },
  methods: {
    update: function() {
      this.loading = true;
      this.companyId = this.$refs.groupResourceSearchChild.companyId;

      this.$api.resourceManagement
        .updateResource({
          companyId: this.companyId,
          resourceManagement: 15
        })
        .then(res => {
          this.loading = false;
          setTimeout(() => {
            this.$Message.success(this.$t('common.updateSuccess'));
          }, 1000);
        });
    },
    //导出
    exportList: function() {
      // 获取子组件数据
      this.companyId = this.$refs.groupResourceSearchChild.companyId;
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: this.$t('common.exporting')
      });
      // 下载Excel 文件
      this.$api.resourceManagement
        .exportAwsIamGroup({
          companyId: this.companyId
        })
        .then(res => {
          let fileName = "aws-iam-group.xls";
          let blob = new Blob([res.data], { type: "application/x-xls" });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
          this.modal_loading = false;
          this.$Message.destroy();
          this.$Message.success(this.$t('common.exportSuccess'));
        });
    }
  }
};
</script>

<style scoped>
.groupResource-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  overflow: hidden;
  font-weight: 600;
}
.groupResource-title > div:nth-child(1) {
  float: left;
}
.groupResource-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.groupResource-top {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/iam_config/group/GroupResource.vue